<template>
  <v-container>
    <app-spinner />
  </v-container>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'

export default Vue.extend({
  name: 'TokenLogin',

  metaInfo: {
    title: 'Login',
  },

  mounted: function () {
    const redirect = this.$router.currentRoute.query.redirect ? this.$router.currentRoute.query.redirect.toString() : '/'
    this.login({ token: this.$router.currentRoute.params.token, redirect })
  },

  methods: {
    ...mapActions('auth', ['login']),
  },
})
</script>
